import React, {useState} from 'react'
import {CircularProgress, Fab, PropTypes, useMediaQuery} from '@mui/material'
import {SvgIconTypeMap} from '@mui/material/SvgIcon/SvgIcon'
import {OverridableComponent} from '@mui/material/OverridableComponent'
import {OverridableStringUnion} from '@mui/types'

type Props = {
    onClick: () => void
    label: string
    enabled: boolean
    color: OverridableStringUnion<PropTypes.Color | 'success' | 'error' | 'info' | 'warning'>
    Icon: OverridableComponent<SvgIconTypeMap> & { muiName: string }
    size?: 'small' | 'medium'
    small?: boolean
}

export const ActionFabButton = ({ small, onClick, label, enabled, color, Icon, size = 'medium' }: Props) => {
    const [actionBusy, setActionBusy] = useState<boolean>(false)

    // @ts-ignore
    const matches = useMediaQuery(theme => theme.breakpoints.up('md'))

    const clicked = async () => {
        setActionBusy(true)
        await onClick()
        setActionBusy(false)
    }

    return !small && matches ? (
        <Fab title={label} onClick={clicked} disabled={!enabled || actionBusy} color={color} variant="extended" size={size}>
            {actionBusy ? <CircularProgress color="secondary" size="1rem" sx={{ mr: 1 }} /> : <Icon sx={{ mr: 1 }} />}
            {label}
        </Fab>
    ) : (
        <Fab title={label} onClick={clicked} disabled={!enabled || actionBusy} color={color} size={size}>
            {actionBusy ? <CircularProgress color="secondary" size="1rem" /> : <Icon />}
        </Fab>
    )
}
